import React, { useState } from 'react';
import Titlebar from '../Titlebar';
import { Input, Avatar } from 'antd';
import employeeData from '../Employeedata.json';
import './Customant5.css';

const { Search } = Input;

function UserSettings() {
  const [searchTerm, setSearchTerm] = useState('');

  // Filter employees based on the search term
  const filteredEmployees = employeeData.employees.filter(employee =>
    employee.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    employee.role.toLowerCase().includes(searchTerm.toLowerCase()) ||
    employee.department.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className='p-5 lg:w-96 m-auto bg-[#F2F2F2] h-screen'>
      <Titlebar title="User Settings" />
      
      <Search 
        placeholder="Search employees" 
        onChange={(e) => setSearchTerm(e.target.value)}
        style={{ width: '100%', marginBottom: '20px' }} 
        className=''
      />

      <div className='grid grid-cols-3 gap-4'>
        {filteredEmployees.map(employee => (
          <div 
            key={employee.employeeId} 
            className='bg-white rounded-2xl flex items-center flex-col py-6'
          >
            <Avatar 
              src={employee.image} 
              size={50} 
              alt={employee.name}
            />
            <h3 className='text-[10px] mt-2 text-center'>{employee.name}</h3>
            <p className='text-[8px] font-light text-gray-500 text-center'>{employee.role}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default UserSettings;
